import { Loader2 } from 'lucide-react'

import { cn } from './utils'

/**
 * The loading spinner. Inside a Button it takes the button's icon size; elsewhere pass a size (`size-6`). It is
 * decorative: the surrounding text or the disabled button says what is loading.
 */
export const Spinner = ({ className }: { className?: string }) => (
  <Loader2 aria-hidden="true" className={cn('animate-spin', className)} />
)
